import { createRoot } from 'react-dom/client';

import ErrorBoundary from './components/ErrorBoundary';
import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';

// Wrap the rendering in a function. ErrorBoundary here covers the root
// <Suspense> in NextApp and every React.lazy() route, auto-recovering from
// post-deploy ChunkLoadError instead of crashing.
function Render() {
  return (
    <ErrorBoundary>
      <NextApp />
    </ErrorBoundary>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Render />);

// Do this once
registerServiceWorker();
